import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HeroPage from './components/Hero';
import Slider from './components/Slider';
import WhoAreWeSection from './components/Whoarewe';
import JobSupportSection from './components/JobSupportSection';
import ServicesSection from './components/ServicesSection';
import Vision from './components/VissionAndMission';
import ServiceCarousel from './components/Clauese';
import VolunteerSection from './components/Voluteer';
import About from './components/About';
import Service from './components/Service';
import ServiceDetail from './components/ServicePage';
import Gallery from './components/Gallery';
import ContactPage from './components/ContactPage'; 
import PartnerPage from './components/PartnerPage';

function HomePage() {
  return (
    <>
      <div
  className="
    flex flex-col min-h-screen bg-cover bg-center relative
    bg-[url('/images/image.png')] sm:bg-[url('/images/bg.jpg')]
  "
>
  <Navbar />
  <HeroPage />
</div>


      <div id="slider" className=" hidden sm:block min-h-screen w-full overflow-hidden bg-black">
        <Slider />
      </div>

      <div id="about" className="min-h-screen w-full bg-white flex items-center justify-center">
        <WhoAreWeSection />
      </div>

      <div id="job" className="min-h-screen">
        <JobSupportSection />
        <ServicesSection />
      </div>

      <Vision />
      <ServiceCarousel />
      <VolunteerSection />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Service />} />
          <Route path="/service/:serviceLink" element={<ServiceDetail />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/contact" element={<ContactPage />} /> 
            <Route path="/partners" element={<PartnerPage />} /> 
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
